import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { moduleSettings } from "../../stores/module-settings.store";
import { InformationText } from "../information-text/information-text";
import { useLocation } from "react-router-dom";

const Message = () => {
  const { i18n } = useTranslation();
  const location = useLocation();

  const generalInfoMessage = moduleSettings.headerMessage(
    i18n.language,
    location.pathname
  );
  return (
    <div>
      {generalInfoMessage ? (
        <InformationText text={generalInfoMessage} collapsable={true} />
      ) : (
        ""
      )}
    </div>
  );
};
export const GeneralMessage = memo(Message);
